import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { featuredGuideImages } from "@/mocks/home";

export default function FeaturedSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const guides = [
    { key: "home.featured.guide1", path: "/hipobuy-guide", imgIndex: 0 },
    { key: "home.featured.guide2", path: "/hipobuy-guide", imgIndex: 1 },
    { key: "home.featured.guide3", path: "/hipobuy-guide", imgIndex: 2 },
    { key: "home.featured.guide4", path: "/hipobuy-guide", imgIndex: 3 },
  ];

  return (
    <section className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-3 text-center font-heading">
          {t("home.featured.title")}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 font-body max-w-xl mx-auto">
          Explorez nos guides détaillés pour maîtriser le hipobuy spreadsheet et optimiser votre gestion de données.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {guides.map((guide) => (
            <button
              key={guide.key}
              type="button"
              onClick={() => { navigate(guide.path); window.scrollTo(0, 0); }}
              className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-background-200/60 hover:shadow-lg transition-all duration-300 cursor-pointer text-left"
            >
              <div className="w-full aspect-[3/2] overflow-hidden">
                <img
                  src={featuredGuideImages[guide.imgIndex]}
                  alt={t(guide.key)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width={600}
                  height={400}
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors font-body leading-snug flex-1">
                  {t(guide.key)}
                </span>
                <div className="flex items-center gap-1 mt-3 text-primary-500 text-xs font-medium font-body">
                  <span>Lire l'article</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}